/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    dark: "Sombre",
    light: "Clair",
    standard: "Standard"
};